module.exports = __webpack_public_path__ + "img/002-whatsapp.02db1b6c.png";